import { ReactComponent as ZocksIcon } from '../../assets/ZocksIcon.svg'
import classNames from 'classnames'

export interface AssistantStatusBadgeProps {
  assistantStatus: 'notStarted' | 'inWaitingRoom' | 'analyzing' | 'analyzed'
}

export const AssistantStatusBadge: React.FC<AssistantStatusBadgeProps> = ({ assistantStatus }) => {
  const assistantStatusTitleMap = {
    notStarted: 'Assistant Not Started',
    inWaitingRoom: 'Assistant In Waiting Room',
    analyzing: 'Assistant Analyzing',
    analyzed: 'Assistant Analyzed',
  }

  return (
    <div
      className={classNames('d-flex align-content-center align-items-center p-1 gap-2 zocks-border-0.25', {
        'zocks-border-primary-light': assistantStatus !== 'analyzed',
        'zocks-border-gray-200 zocks-bg-color-gray-200': assistantStatus === 'analyzed',
        'zocks-bg-color-primary-light': assistantStatus === 'analyzing',
      })}
    >
      <ZocksIcon width={16} height={16} />
      <span className='button-small'>{assistantStatusTitleMap[assistantStatus]}</span>
    </div>
  )
}
